import React, { useEffect } from "react";
import styled from "styled-components";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import PowerBiLogo from "../../../assets/temp/powerbi-logo.jpeg";
import PowerBi1 from "../../../assets/temp/powerbi-screen-1.png";
import PowerBi2 from "../../../assets/temp/powerbi-screen-2.png";
import PowerBi3 from "../../../assets/temp/powerbi-screen-3.png";

// Styled components
const Container = styled.div`
  height: 100vw;
  max-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100vw;
`;

const Img = styled.img`
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  object-fit: contain;
  width: 100vw;
`;

const PowerBiImg = styled.img`
  bottom: 20px;
  height: auto;
  opacity: 0.75;
  position: absolute;
  right: 20px;
  width: 200px;
`;

const responsive = {
  all: {
    breakpoint: { max: 10000, min: 0 },
    items: 1
  },
};

const PowerBi = () => {
  useEffect(() => {
    document.title = 'Power BI';
  }, []);

  return (
    <Container>
      <Carousel responsive={responsive}>
        <div>
          <Img alt="" src={PowerBi1} />
        </div>
        <div>
          <Img alt="" src={PowerBi2} />
        </div>
        <div>
          <Img alt="" src={PowerBi3} />
        </div>
      </Carousel>

      <PowerBiImg
        src={PowerBiLogo}
      />
    </Container>
  );
};

export default PowerBi;
